export default [
    {
        path: "/app/:userDeptRoleId/notifi",
        components: {
            default: () => import("../views/notification/index.vue")
        },
        name: "notifi"
    },
    {
        path: "/app/:userDeptRoleId/view-notifi",
        components: {
            default: () => import("../views/notification/index-view.vue")
        },
        name: "myNotifi"
    },
    {
        path: "/app/:userDeptRoleId/notification/detail/:id",
        components: {
            default: () => import("../views/notification/index.vue"),
            detail: () => import("../views/notification/detail.vue")
        },
        name: "notifiDetail"
    },
    {
        path: "/app/:userDeptRoleId/view-notification/detail/:id",
        components: {
            default: () => import("../views/notification/index-view.vue"),
            detail: () => import("../views/notification/detail-view.vue")
        },
        name: "myNotifiDetail"
    },
];



// WEBPACK FOOTER //
// ./src/router/notifi.js